<template>
  <div class="fin-news-details">
    <Portal to="breadcrumb_newsDetail" v-if="value">
      {{ $vuetify.breakpoint.xs && value.title.length > 10 ? 'Artikel' : value.title }}
    </Portal>
    <v-img v-if="!hideThumbnail"
           :aspect-ratio="hasImg() ? 16/6 : 16/0"
           :src="value.teaserThumbnailUrl">
      <v-container fill-height fluid ma-0 slot="placeholder">
        <v-row v-if="hasImg()" align="center" justify="center">
          <fin-logo-full dark loading></fin-logo-full>
        </v-row>
      </v-container>
      <v-card-title>
        <fin-time-ago :datetime="value.datePublished" :style="{color: timeColor()}"></fin-time-ago>
        <v-spacer/>
        <v-btn :dark="hasImg()" icon @click="close">
          <v-icon>icon-close</v-icon>
        </v-btn>
      </v-card-title>
    </v-img>
    <v-container :class="hasImg() ? 'py-12' : 'py-0'"
                 v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
      <h1>
        {{ value.title }}
        <fin-bookmark-btn contentStyle="position: absolute; right: 20px"/>
      </h1>

      <div class="my-12" v-html="value.content"></div>
    </v-container>
  </div>
</template>

<script>
import finLogoFull from '@/components/common/logo/LogoFull/index'
import finBookmarkBtn from '@/components/common/BookmarkBtn'
import KeyFunctionMixin from '@/mixins/KeyFunction'

export default {
  name: 'fin-news-details',
  components: {
    finBookmarkBtn,
    finLogoFull
  },
  props: {
    value: {}
  },
  data() {
    return {
      hideThumbnail: process.env.VUE_APP_HIDE_NEWS_THUMBNAILS === 'true'
    }
  },
  mixins: [KeyFunctionMixin],
  methods: {
    close() {
      this.$emit('close')
    },
    onKey(event) {
      this.keyFunction(event, 'Escape', () => {
        this.close()
      })
    },
    hasImg() {
      return this.value.teaserThumbnailUrl ? true : false
    },
    timeColor() {
      return this.hasImg() ? 'var(--white)' : 'var(--cool-grey)'
    }
  }

}
</script>
<style lang="scss" scoped>
.v-image__image--cover {
  background-position: center top !important;
}
</style>
